function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent, createRef } from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';
import DelayFeedback from './DelayFeedback';
/**
 * The Trigger component creates a reference point for interactions which trigger
 * some UI to be shown or other interaction which requires the container elements reference.
 * Generally a Trigger can be used in lieu of a button where you need exactly the contained
 * element for positioning purposes. If you do not care what the containing target is or
 * about handling hover delays then direct use of `Button` should be preferred.
 *
 * ## Composed of
 * - [Button](../Button/README.md)
 *
 * ## Related Components
 * - [Anchored](../Anchored/README.md)
 *
 * ## Usage
 *
 * ```jsx
 *<Trigger onTrigger={({ target }) => console.log('do something with', target)}>
 *  UI here
 *</Trigger>
 *```
 *
 * ## Props
 */

var Trigger = /*#__PURE__*/function (_PureComponent) {
  _inherits(Trigger, _PureComponent);

  var _super = _createSuper(Trigger);

  function Trigger(props) {
    var _this;

    _classCallCheck(this, Trigger);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "state", {
      isActive: false,
      isInitiated: false
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseEnter", function () {
      var _this$props = _this.props,
          onTrigger = _this$props.onTrigger,
          hoverDelay = _this$props.hoverDelay,
          hoverable = _this$props.hoverable;
      if (!hoverable) return;

      _this.setState({
        isInitiated: true
      });

      _this._timeout = setTimeout(function () {
        _this.setState({
          isActive: true
        });

        onTrigger({
          target: _this._node.current
        });
      }, hoverDelay);
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseLeave", function () {
      var hoverable = _this.props.hoverable;
      if (!hoverable) return;
      clearTimeout(_this._timeout);

      _this.setState({
        isActive: false,
        isInitiated: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onFocus", function () {
      _this.onMouseEnter();
    });

    _defineProperty(_assertThisInitialized(_this), "onBlur", function () {
      _this.onMouseLeave();
    });

    _defineProperty(_assertThisInitialized(_this), "onClick", function () {
      var onTrigger = _this.props.onTrigger;
      clearTimeout(_this._timeout);

      _this.setState({
        isActive: true
      });

      onTrigger({
        target: _this._node.current
      });
    });

    _this._node = /*#__PURE__*/createRef();
    return _this;
  }

  _createClass(Trigger, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this._timeout);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          hoverDelay = _this$props2.hoverDelay,
          qa = _this$props2.qa,
          hoverable = _this$props2.hoverable,
          variant = _this$props2.variant,
          className = _this$props2.className,
          ctaType = _this$props2.ctaType,
          path = _this$props2.path;
      var _this$state = this.state,
          isActive = _this$state.isActive,
          isInitiated = _this$state.isInitiated;

      var _Trigger$getClassName = Trigger.getClassName({
        className: className,
        isInitiated: isInitiated
      }),
          root = _Trigger$getClassName.root,
          chart = _Trigger$getClassName.chart;

      return /*#__PURE__*/React.createElement(Button, _extends({}, this.props, {
        qa: qa,
        ref: this._node,
        className: root,
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave,
        onClick: this.onClick,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        variant: variant,
        ctaType: ctaType
      }), children, hoverable && /*#__PURE__*/React.createElement(DelayFeedback, {
        qa: "".concat(qa, "#delayFeedback"),
        className: chart,
        isActive: isActive,
        isInitiated: isInitiated,
        hoverDelay: hoverDelay,
        path: path
      }));
    }
  }]);

  return Trigger;
}(PureComponent);

Trigger.getClassName = function (_ref) {
  var className = _ref.className;
  return {
    root: className,
    chart: 'psw-hover-trigger-chart psw-layer'
  };
};

Trigger.defaultProps = {
  className: '',
  qa: '',
  children: null,
  onTrigger: function onTrigger() {},
  hoverDelay: 350,
  hoverable: false,
  variant: 'content',
  ctaType: '',
  path: null
};
Trigger.propTypes = {
  /**
   * Allows adding a custom class or series of classes on the component
   * useful for setting margin or padding
   */
  className: PropTypes.string,

  /**
   * QA selector attribute used to target important elements for test validation
   */
  qa: PropTypes.string,

  /**
   * The UI to make into a trigger
   */
  children: PropTypes.node,

  /**
   * The event callback to be called when the trigger activated
   */
  onTrigger: PropTypes.func,

  /**
   * The amount of time to wait in milliseconds before emitting a trigger event after first hovered
   * or focused
   */
  hoverDelay: PropTypes.number,

  /**
   * Whether or not the trigger should emit an event on hover
   */
  hoverable: PropTypes.bool,

  /**
   * Presentational variant to apply
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(['solid', 'outline', 'content', 'quick-action', 'option']), PropTypes.string]),

  /**
   * The type of button in design language
   */
  ctaType: PropTypes.oneOf(['', 'primary', 'primary-1', 'primary-2', 'secondary', 'secondary-1', 'secondary-2', 'secondary-3', 'secondary-4', 'utility', 'alt-secondary', 'purchase', 'tertiary']),
  path: PropTypes.oneOf(['line', 'circle'])
};
export default Trigger;